import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/humidity-calculator',
  component: () => import('../../routes/HumidityCalculator.svelte'),
  card: {
    id: 'humidity-calculator',
    title: 'Humidity & Heat Index',
    description: 'Calculate heat index, wind chill, dew point, and get comfort level and health advisories based on temperature and humidity.',
    icon: 'water_drop',
    iconBgClass: 'bg-sky-50',
    iconTextClass: 'text-sky-600',
    href: '/humidity-calculator',
    category: 'Health & Fitness',
  },
  seo: {
    title: 'Humidity & Heat Index Calculator – Feels-Like Temperature & Comfort',
    description:
      'Free humidity calculator computes heat index, wind chill, and dew point. Enter temperature and relative humidity to get apparent feels-like temperature, comfort level, and health advisories.',
  },
};

export default meta;
